export default __webpack_public_path__ + "static/media/clinks.38060059.svg";